/* ==========================================================================
   HERBALEVER — Instagram Reels Section
   Prefix: iff3eef-
   Append this block to the END of assets/herbalever.js
   Do not remove or edit any existing code in this file.
   ========================================================================== */

(function () {
  'use strict';

  var iff3eefInitializedSections = {};

  function iff3eefQueryAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function iff3eefInitReelsSection(sectionId) {
    var section = document.getElementById(sectionId);
    if (!section) return;

    // Avoid double-binding the same section (theme editor re-renders).
    if (iff3eefInitializedSections[sectionId]) {
      iff3eefInitializedSections[sectionId].destroy();
    }

    var track = section.querySelector('[data-iff3eef-track]');
    var cards = iff3eefQueryAll(section, '[data-iff3eef-card]');
    var prevBtn = section.querySelector('[data-iff3eef-prev]');
    var nextBtn = section.querySelector('[data-iff3eef-next]');
    var dotsWrap = section.querySelector('[data-iff3eef-dots]');
    var modal = section.querySelector('[data-iff3eef-modal]');
    var modalOverlay = section.querySelector('[data-iff3eef-modal-overlay]');
    var modalClose = section.querySelector('[data-iff3eef-modal-close]');
    var modalMedia = section.querySelector('[data-iff3eef-modal-media]');

    var shouldAutoplay = section.getAttribute('data-iff3eef-autoplay') === 'true';
    var cleanupFns = [];
    var activeCardForModal = null;

    /* ---------------- Fade-up reveal ---------------- */

    var fadeTargets = iff3eefQueryAll(section, '.iff3eef-fade-up');
    if ('IntersectionObserver' in window && fadeTargets.length) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('iff3eef-in-view');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      fadeTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
      cleanupFns.push(function () {
        revealObserver.disconnect();
      });
    } else {
      fadeTargets.forEach(function (el) {
        el.classList.add('iff3eef-in-view');
      });
    }

    /* ---------------- Video autoplay-in-view ---------------- */

    var videoEls = iff3eefQueryAll(section, '.iff3eef-reel-video');

    if (shouldAutoplay && 'IntersectionObserver' in window && videoEls.length) {
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                  /* Autoplay blocked by browser; ignore silently. */
                });
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      videoEls.forEach(function (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        videoObserver.observe(video);
      });
      cleanupFns.push(function () {
        videoObserver.disconnect();
      });
    }

    /* ---------------- Carousel navigation ---------------- */

    function iff3eefGetStep() {
      if (!cards.length) return 0;
      var card = cards[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function iff3eefUpdateArrowState() {
      if (!track || (!prevBtn && !nextBtn)) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function iff3eefUpdateDots() {
      if (!dotsWrap) return;
      var dots = iff3eefQueryAll(dotsWrap, '.iff3eef-dot');
      if (!dots.length) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var activeIndex = Math.round(ratio * (dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('iff3eef-dot-active', i === activeIndex);
        dot.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
    }

    function iff3eefBuildDots() {
      if (!dotsWrap || !cards.length) return;
      dotsWrap.innerHTML = '';
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'iff3eef-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to reel ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: iff3eefGetStep() * i, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      iff3eefUpdateDots();
    }

    if (prevBtn) {
      var handlePrev = function () {
        if (track.scrollLeft <= 2) {
          // Loop to the end.
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -iff3eefGetStep(), behavior: 'smooth' });
        }
      };
      prevBtn.addEventListener('click', handlePrev);
      cleanupFns.push(function () {
        prevBtn.removeEventListener('click', handlePrev);
      });
    }

    if (nextBtn) {
      var handleNext = function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= maxScroll) {
          // Loop back to the start.
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: iff3eefGetStep(), behavior: 'smooth' });
        }
      };
      nextBtn.addEventListener('click', handleNext);
      cleanupFns.push(function () {
        nextBtn.removeEventListener('click', handleNext);
      });
    }

    if (track) {
      var handleScroll = function () {
        window.requestAnimationFrame(function () {
          iff3eefUpdateArrowState();
          iff3eefUpdateDots();
        });
      };
      track.addEventListener('scroll', handleScroll, { passive: true });
      cleanupFns.push(function () {
        track.removeEventListener('scroll', handleScroll);
      });

      var handleResize = function () {
        iff3eefUpdateArrowState();
        iff3eefUpdateDots();
      };
      window.addEventListener('resize', handleResize);
      cleanupFns.push(function () {
        window.removeEventListener('resize', handleResize);
      });
    }

    iff3eefBuildDots();
    iff3eefUpdateArrowState();

    /* ---------------- Card click: Instagram vs Modal ---------------- */

    function iff3eefOpenModal(card) {
      if (!modal || !modalMedia) return;
      activeCardForModal = card;

      var wrap = card.querySelector('[data-iff3eef-video-wrap]');
      var video = card.querySelector('.iff3eef-reel-video');
      modalMedia.innerHTML = '';

      if (video) {
        // Move the actual video element into the modal so its buffered
        // source is reused rather than re-downloaded.
        modalMedia.appendChild(video);
        video.muted = true;
        video.controls = true;
        video.currentTime = 0;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        var img = card.querySelector('.iff3eef-reel-thumb');
        if (img) {
          var clone = img.cloneNode(true);
          modalMedia.appendChild(clone);
        }
      }

      modal.setAttribute('data-iff3eef-open', 'true');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalClose && modalClose.focus();
    }

    function iff3eefCloseModal() {
      if (!modal) return;
      var video = modalMedia ? modalMedia.querySelector('.iff3eef-reel-video') : null;

      if (video) {
        video.pause();
        video.controls = false;
        video.muted = true;
        if (activeCardForModal) {
          var wrap = activeCardForModal.querySelector('[data-iff3eef-video-wrap]');
          if (wrap) wrap.appendChild(video);
        }
      }

      modal.setAttribute('data-iff3eef-open', 'false');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      activeCardForModal = null;
    }

    cards.forEach(function (card) {
      var handleCardActivate = function (event) {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        if (event.type === 'keydown') event.preventDefault();

        var hasIg = card.getAttribute('data-iff3eef-has-ig') === 'true';
        var igUrl = card.getAttribute('data-iff3eef-ig-url');

        if (hasIg && igUrl) {
          window.open(igUrl, '_blank', 'noopener,noreferrer');
        } else {
          iff3eefOpenModal(card);
        }
      };

      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.addEventListener('click', handleCardActivate);
      card.addEventListener('keydown', handleCardActivate);

      cleanupFns.push(function () {
        card.removeEventListener('click', handleCardActivate);
        card.removeEventListener('keydown', handleCardActivate);
      });
    });

    if (modalOverlay) {
      modalOverlay.addEventListener('click', iff3eefCloseModal);
      cleanupFns.push(function () {
        modalOverlay.removeEventListener('click', iff3eefCloseModal);
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', iff3eefCloseModal);
      cleanupFns.push(function () {
        modalClose.removeEventListener('click', iff3eefCloseModal);
      });
    }

    var handleKeydown = function (event) {
      if (event.key === 'Escape' && modal && modal.getAttribute('data-iff3eef-open') === 'true') {
        iff3eefCloseModal();
      }
    };
    document.addEventListener('keydown', handleKeydown);
    cleanupFns.push(function () {
      document.removeEventListener('keydown', handleKeydown);
    });

    iff3eefInitializedSections[sectionId] = {
      destroy: function () {
        cleanupFns.forEach(function (fn) {
          fn();
        });
      }
    };
  }

  function iff3eefInitAll() {
    iff3eefQueryAll(document, '.iff3eef-reels-section').forEach(function (section) {
      iff3eefInitReelsSection(section.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iff3eefInitAll);
  } else {
    iff3eefInitAll();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.iff3eef-reels-section');
    if (section && iff3eefInitializedSections[section.id]) {
      iff3eefInitializedSections[section.id].destroy();
      delete iff3eefInitializedSections[section.id];
    }
  });

  window.iff3eefInitReelsSection = iff3eefInitReelsSection;
})();
